<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Manage Recurring Membership</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="mb-3">
      <div><strong>Membership:</strong> {{ membership.name }}</div>
      <div>
        <strong>Owner:</strong>
        <a [routerLink]="['/customers', membership.owner_id, 'memberships-and-passes']"
           target="_blank" rel="noopener">
          {{ membership.owner_first_name }} {{ membership.owner_last_name }}
        </a>
      </div>
      <div>
        <strong>Members:</strong>
        <ng-container *ngIf="(membership.all_customers.length + membership.unlinked_customers.length) > 0; else noMembers">
          <ng-container *ngFor="let member of membership.all_customers; let isLast = last;">
            <a [routerLink]="['/customers', member.id, 'memberships-and-passes']"
               target="_blank" rel="noopener">
              {{ member.first_name }} {{ member.last_name }}
            </a>{{ (isLast && membership.unlinked_customers.length === 0) ? '' : ', ' }}
          </ng-container>
          <ng-container *ngFor="let unlinked of membership.unlinked_customers; let isLast = last;">
            <span>{{ unlinked.first_name }} {{ unlinked.last_name }}</span>{{ isLast ? '' : ', ' }}
          </ng-container>
        </ng-container>
        <ng-template #noMembers>
          <span class="text-muted"> None</span>
        </ng-template>
      </div>
    </div>

    <div class="alert alert-info mb-0" role="alert" *ngIf="!hasAvailableActions()">
      This membership has ended and there are no actions available for it.
    </div>

    <div class="form-group" *ngIf="hasAvailableActions()">
      <label for="actionSelect">Action</label>
      <select class="custom-select" id="actionSelect" [(ngModel)]="selectedAction">
        <option [ngValue]="null">
          ---
        </option>
        <option [ngValue]="ActionList.cancelImmediately"
                *ngIf="actionIsAvailable(ActionList.cancelImmediately)">
          Cancel (Immediately)
        </option>
        <option [ngValue]="ActionList.addPaymentMethod"
                *ngIf="actionIsAvailable(ActionList.addPaymentMethod)">
          Add Payment Method
        </option>
        <option [ngValue]="ActionList.cancelUnactivated"
                *ngIf="actionIsAvailable(ActionList.cancelUnactivated)">
          Cancel Unactivated Purchase
        </option>
        <option [ngValue]="ActionList.cancelFutureBillingDate"
                *ngIf="actionIsAvailable(ActionList.cancelFutureBillingDate)">
          Cancel (Future Billing Date)
        </option>
        <option [ngValue]="ActionList.undoCancelFutureBillingDate"
                *ngIf="actionIsAvailable(ActionList.undoCancelFutureBillingDate)">
          Undo Cancel (Future Billing Date)
        </option>
        <option [ngValue]="ActionList.freeze"
                *ngIf="actionIsAvailable(ActionList.freeze)">
          Freeze
        </option>
        <option [ngValue]="ActionList.freezeIndividual"
                *ngIf="actionIsAvailable(ActionList.freezeIndividual)">
          Freeze Individual Member
        </option>
        <option [ngValue]="ActionList.undoScheduledFreeze"
                *ngIf="actionIsAvailable(ActionList.undoScheduledFreeze)">
          Undo Scheduled Freeze
        </option>
        <option [ngValue]="ActionList.undoScheduledFreezeIndividual"
                *ngIf="actionIsAvailable(ActionList.undoScheduledFreezeIndividual)">
          Undo Scheduled Individual Freeze
        </option>
        <option [ngValue]="ActionList.unfreeze"
                *ngIf="actionIsAvailable(ActionList.unfreeze)">
          Unfreeze
        </option>
        <option [ngValue]="ActionList.scheduleUnfreeze"
                *ngIf="actionIsAvailable(ActionList.scheduleUnfreeze)">
          Schedule Unfreeze
        </option>
        <option [ngValue]="ActionList.scheduleUnfreezeIndividual"
                *ngIf="actionIsAvailable(ActionList.scheduleUnfreezeIndividual)">
          Unfreeze Individual Member
        </option>
        <option [ngValue]="ActionList.undoScheduledUnfreeze"
                *ngIf="actionIsAvailable(ActionList.undoScheduledUnfreeze)">
          Undo Scheduled Unfreeze
        </option>
        <option [ngValue]="ActionList.undoScheduledUnfreezeIndividual"
                *ngIf="actionIsAvailable(ActionList.undoScheduledUnfreezeIndividual)">
          Undo Scheduled Individual Unfreeze
        </option>
        <option [ngValue]="ActionList.editStartDate"
                *ngIf="actionIsAvailable(ActionList.editStartDate)">
          Edit Start Date
        </option>
        <option [ngValue]="ActionList.editBillDate"
                *ngIf="actionIsAvailable(ActionList.editBillDate)">
          Edit Bill Date
        </option>
        <option [ngValue]="ActionList.editAddOnsImmediately"
                *ngIf="actionIsAvailable(ActionList.editAddOnsImmediately)">
          Edit Add-Ons (Immediately)
        </option>
        <option [ngValue]="ActionList.editAddOnsNextBillDate"
                *ngIf="actionIsAvailable(ActionList.editAddOnsNextBillDate)">
          Edit Add-Ons (Next Bill Date)
        </option>
        <option [ngValue]="ActionList.reassign"
                *ngIf="actionIsAvailable(ActionList.reassign)">
          Reassign
        </option>
        <option [ngValue]="ActionList.editMembers"
                *ngIf="actionIsAvailable(ActionList.editMembers)">
          Edit Members (Immediately)
        </option>
        <option [ngValue]="ActionList.addMemberNextBillDate"
                *ngIf="actionIsAvailable(ActionList.addMemberNextBillDate)">
          Add Member (Next Bill Date)
        </option>
        <option [ngValue]="ActionList.removeMemberNextBillDate"
                *ngIf="actionIsAvailable(ActionList.removeMemberNextBillDate)">
          Remove Member (Next Bill Date)
        </option>
        <option [ngValue]="ActionList.editRecurringDiscount"
                *ngIf="actionIsAvailable(ActionList.editRecurringDiscount)">
          Edit Recurring Discount
        </option>
        <option [ngValue]="ActionList.editOneOffDiscount"
                *ngIf="actionIsAvailable(ActionList.editOneOffDiscount)">
          Edit One-Time Discount
        </option>
        <option [ngValue]="ActionList.fixFailedPayment"
                *ngIf="actionIsAvailable(ActionList.fixFailedPayment)">
          Fix Failed Payment
        </option>
        <option [ngValue]="ActionList.purchaseUpfrontPaymentOption"
                *ngIf="actionIsAvailable(ActionList.purchaseUpfrontPaymentOption)">
          Purchase Upfront Payment Option
        </option>
        <option [ngValue]="ActionList.changePaymentMethod"
                *ngIf="actionIsAvailable(ActionList.changePaymentMethod)">
          Change Payment Method
        </option>
        <option [ngValue]="ActionList.changeRoster"
                *ngIf="actionIsAvailable(ActionList.changeRoster)">
          Change Roster
        </option>
      </select>
      <small class="form-text text-muted" *ngIf="billDateBlockedByScheduledChange()">
        To edit the bill date, undo the scheduled cancellation or freeze first, then reschedule it after the bill date is changed.
      </small>
    </div>

    <app-edit-recurring-customer-membership-cancel-immediately
      *ngIf="selectedAction === ActionList.cancelImmediately"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-cancel-immediately>

    <app-edit-recurring-customer-membership-cancel-future-bill-date
      *ngIf="selectedAction === ActionList.cancelFutureBillingDate"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-cancel-future-bill-date>

    <app-edit-recurring-customer-membership-undo-cancel-future-bill-date
      *ngIf="selectedAction === ActionList.undoCancelFutureBillingDate"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-undo-cancel-future-bill-date>

    <app-edit-recurring-customer-membership-freeze
      *ngIf="selectedAction === ActionList.freeze"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-freeze>

    <app-edit-recurring-customer-membership-freeze-individual
      *ngIf="selectedAction === ActionList.freezeIndividual"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-freeze-individual>

    <!--suppress TypeScriptValidateTypes -->
    <app-edit-recurring-customer-membership-undo-scheduled-freeze
      *ngIf="[ActionList.undoScheduledFreeze, ActionList.undoScheduledUnfreeze].includes(selectedAction)"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-undo-scheduled-freeze>

    <!--suppress TypeScriptValidateTypes -->
    <app-edit-recurring-customer-membership-undo-scheduled-freeze-individual
      *ngIf="[ActionList.undoScheduledFreezeIndividual, ActionList.undoScheduledUnfreezeIndividual].includes(selectedAction)"
      [membership]="membership"
      [unfreezeOnly]="selectedAction === ActionList.undoScheduledUnfreezeIndividual"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-undo-scheduled-freeze-individual>

    <app-edit-recurring-customer-membership-unfreeze
      *ngIf="selectedAction === ActionList.unfreeze"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-unfreeze>

    <app-edit-recurring-customer-membership-schedule-unfreeze
      *ngIf="selectedAction === ActionList.scheduleUnfreeze"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-schedule-unfreeze>

    <app-edit-recurring-customer-membership-schedule-unfreeze-individual
      *ngIf="selectedAction === ActionList.scheduleUnfreezeIndividual"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-schedule-unfreeze-individual>

    <app-edit-recurring-customer-membership-add-payment-method
      *ngIf="selectedAction === ActionList.addPaymentMethod"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-add-payment-method>

    <app-cancel-unactivated-customer-membership
      *ngIf="selectedAction === ActionList.cancelUnactivated"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-cancel-unactivated-customer-membership>

    <app-edit-customer-membership-start-date
      *ngIf="selectedAction === ActionList.editStartDate"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-customer-membership-start-date>

    <app-edit-customer-membership-bill-date
      *ngIf="selectedAction === ActionList.editBillDate"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-customer-membership-bill-date>

    <app-edit-customer-membership-add-ons-immediately
      *ngIf="selectedAction === ActionList.editAddOnsImmediately"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-customer-membership-add-ons-immediately>

    <app-edit-recurring-customer-membership-add-ons-next-bill-date
      *ngIf="selectedAction === ActionList.editAddOnsNextBillDate"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-add-ons-next-bill-date>

    <app-reassign-customer-membership
      *ngIf="selectedAction === ActionList.reassign"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-reassign-customer-membership>

    <app-edit-group-membership-members-immediately
      *ngIf="selectedAction === ActionList.editMembers"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-group-membership-members-immediately>

    <app-add-group-membership-member-next-bill-date
      *ngIf="selectedAction === ActionList.addMemberNextBillDate"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-add-group-membership-member-next-bill-date>

    <app-remove-group-membership-member-next-bill-date
      *ngIf="selectedAction === ActionList.removeMemberNextBillDate"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-remove-group-membership-member-next-bill-date>

    <app-edit-recurring-customer-membership-recurring-discount
      *ngIf="selectedAction === ActionList.editRecurringDiscount"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-recurring-discount>

    <app-edit-recurring-customer-membership-one-off-discount
      *ngIf="selectedAction === ActionList.editOneOffDiscount"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-one-off-discount>

    <app-edit-recurring-customer-membership-fix-failed-payment
      *ngIf="selectedAction === ActionList.fixFailedPayment"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-fix-failed-payment>

    <app-edit-recurring-customer-membership-purchase-upfront-payment-option
      *ngIf="selectedAction === ActionList.purchaseUpfrontPaymentOption"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-purchase-upfront-payment-option>

    <app-edit-recurring-customer-membership-change-payment-method
      *ngIf="selectedAction === ActionList.changePaymentMethod"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-recurring-customer-membership-change-payment-method>

    <app-change-customer-membership-roster
      *ngIf="selectedAction === ActionList.changeRoster"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-change-customer-membership-roster>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loading && hasAvailableActions()"
            [disabled]="selectedAction === null"
            [class.disabled]="selectedAction === null"
            (click)="handleSubmit()">
      {{ getSubmitButtonText() }}
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loading">
      Loading...
    </button>
  </div>

</ng-container>
